import { Link } from "react-router-dom";
import SeoHead from "@shared/components/Seo/SeoHead";
import { APP_NAME } from "@shared/util/brand";

const COPY = {
  webinars: {
    title: "AI webinar summary tool",
    h1: "Turn webinars into chapters, quotes, and highlight reels",
    body: "WebinarVault auto-transcribes your webinar, generates navigable chapters, extracts Magic Quotes for social clips, and builds Auto-Condense highlight videos—without an editor.",
    faqs: [
      {
        q: "How fast can I get quotes from a webinar?",
        a: "Most uploads produce chapters and pull quotes within minutes of processing, depending on video length.",
      },
      {
        q: "Can I share clips without re-editing in Premiere?",
        a: "Yes. Select Magic Quotes and export clip timecodes or an Auto-Condense reel directly from the app.",
      },
    ],
  },
  education: {
    title: "Education video condensing",
    h1: "Condense long lectures into study-friendly highlights",
    body: "Teachers and trainers use WebinarVault to segment lectures, surface key definitions, and publish short recap videos for students.",
    faqs: [
      {
        q: "Does it work for multi-hour recordings?",
        a: "Yes. WebinarVault is built for long-form content with chapter navigation and quote-level export.",
      },
    ],
  },
  sports: {
    title: "Sports video intelligence",
    h1: "Extract moments from game film and broadcasts",
    body: "Scorebug-aware workflows (on Condense) plus chapter and quote extraction help sports media teams find highlights faster.",
    faqs: [
      {
        q: "Is scorebug detection included?",
        a: "Scorebug OCR is available on Condense brand deployments; WebinarVault focuses on quote and chapter intelligence.",
      },
    ],
  },
};

export default function UseCasePage({ slug }) {
  const page = COPY[slug] || COPY.webinars;

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 px-6 py-16 max-w-3xl mx-auto">
      <SeoHead title={page.title} description={page.body} path={`/use-cases/${slug}`} />
      <Link to="/" className="text-sm text-blue-400 hover:underline mb-8 inline-block">
        ← {APP_NAME}
      </Link>
      <h1 className="text-3xl font-bold mb-4">{page.h1}</h1>
      <p className="text-lg text-slate-300 leading-relaxed mb-10">{page.body}</p>
      <Link
        to="/register"
        className="inline-block bg-blue-600 hover:bg-blue-500 text-white font-semibold px-6 py-3 rounded-lg mb-12"
      >
        Start free — upload your first video
      </Link>
      <section className="space-y-6 border-t border-slate-800 pt-10">
        <h2 className="text-xl font-semibold text-slate-200">FAQ</h2>
        {page.faqs.map((f) => (
          <div key={f.q}>
            <h3 className="text-base font-medium text-white mb-2">{f.q}</h3>
            <p className="text-slate-400 text-sm leading-relaxed">{f.a}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
